import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    isAuthenticated: false,
    email: '',
    name: '',
  },
  reducers: {
    setUser(state, action) {
      state.name = action.payload.displayName;
      state.email = action.payload.email;
      state.user = action.payload;
      state.isAuthenticated = true;
    },

    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.email = '';
      state.name = '';
      localStorage.removeItem('user');
    },

    setIsAuthenticated(state, action) {
      state.isAuthenticated = action.payload;
    },
  },
});

export const authActions = authSlice.actions;

export default authSlice;
